import React, { useEffect, useState } from "react";
import {
  Checkbox,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
} from "@mui/material";
import { FilterAlt } from "@mui/icons-material";
import { CustomIconButton } from "../../shared/CustomIconButton";
// import axios from "axios";
import Search from "../../shared/Search";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";

import BorderColorIcon from "@mui/icons-material/BorderColor";

import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Modal from "@mui/material/Modal";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";

import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";

import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";

import { toast } from "react-toastify";
import { useFormik } from "formik";
import axiosInstance from "../../config/axios";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 500,
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
  rounded: 2,
};

const CustomNotification = () => {
  const [data, setData] = useState([]);
  const superuserId = localStorage.getItem("is_superuser");
  const [open, setOpen] = React.useState(false);
  const [tagData, setTagData] = useState([]);
  const [subjectData, setSubjectData] = useState([]);
  const [subject, setSubject] = useState("");
  const [title, setTitle] = useState("");
  const [tag, setTag] = useState("");
  const [heading, setHeading] = useState("");
  const [description, setDescription] = useState("");
  const [rowData, setRowData] = useState({});
  const [ids, setIds] = useState(null);

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const transitionData = () => {
    {
      superuserId == "true"
        ? axiosInstance
            .post(
              `api/custome-notifier-list-data/`,
              { page: "", search_values: "" },
              {
                headers: {
                  Token: localStorage.getItem("Token"),
                },
              },
            )
            .then((response) => {
              setData(response?.data?.data);
            })
            .catch((error) => {
              console.log("", error);
            })
        : axiosInstance
            .post(
              `api/multivendor-vendor-wallets-transection-admin/`,
              {},
              {
                headers: {
                  // Token: localStorage.getItem("Token"),
                  Token: "d3c1e6d0a7c3645507d87e10ecdd970933408c5f",
                },
              },
            )
            .then((response) => {
              setData(response?.data?.vendor_wallet_transection);
            })
            .catch((error) => {
              console.log("", error);
            });
    }
  };

  useEffect(() => {
    transitionData();
  }, []);

  const hangleCancel = () => {
    handleClose();
  };
  const editFunctionality = (event, row) => {
    event.preventDefault();
    handleOpen();
    console.log("row data==>", row);
    setIds(row?.id);
    setSubject(row?.subject);
    setTitle(row?.title);
    // setTag(row?.tag);
    // setHeading(row?.heading);
    setRowData(row);
    setDescription(row?.body);
  };
  const updateNotification = () => {
    const fd = new FormData();
    fd.append("cus_notifier_id", ids);
    fd.append("subject", subject);
    fd.append("tag", tag || rowData?.tag);
    fd.append("heading", heading || rowData?.subject);
    fd.append("title", title);
    fd.append("body", description);
    axiosInstance
      .put(`api/update-custom-notifier-data/`, fd, {
        headers: {
          Token: localStorage.getItem("Token"),
        },
      })
      .then((response) => {
        console.log("heading Data===>", response?.data);
        toast.success(response?.data?.msg);
        handleClose();
      })
      .catch((error) => {
        console.log("", error);
      });
  };

  const subjectDataList = () => {
    axiosInstance
      .get(`api/heading-notification-choices-list/`, {
        headers: {
          Token: localStorage.getItem("Token"),
        },
      })
      .then((response) => {
        console.log("heading Data===>", response?.data?.headings);
        setSubjectData(response?.data?.headings);
      })
      .catch((error) => {
        console.log("", error);
      });
  };
  useEffect(() => {
    subjectDataList();
  }, []);

  const tagDataList = () => {
    axiosInstance
      .get(`api/tag-notification-choices-list/`, {
        headers: {
          Token: localStorage.getItem("Token"),
        },
      })
      .then((response) => {
        console.log("tag Data===>", response?.data?.tag);
        setTagData(response?.data?.tag);
      })
      .catch((error) => {
        console.log("", error);
      });
  };
  useEffect(() => {
    tagDataList();
  }, []);

  return (
    <div className=" !bg-slate-100">
      <div className="flex justify-between">
        <div className="p-2">
          <p className="text-xl !text-black font font-bold">
            custom Notification
          </p>
        </div>
        <div className="p-2 pt-5">{/* <CreateResellers /> */}</div>
      </div>
      <div className="flex flex-col !rounded !text-black bg-slate-100 shadow-card shadow-zinc-600 m-2">
        <div className="flex items-center justify-between my-2">
          <span className="flex  gap-3">
            {/* <CustomIconButton>
              <FilterAlt className="!text-black" />
            </CustomIconButton> */}
            <input
              type="text"
              //   value={searchQuery}
              className="!border-3 !border-black !w-72 px-2 mx-3 rounded-md py-1"
              placeholder="search"
              style={{ border: "1px solid black" }}
              //   onChange={(event) => setSearchQuery(event.target.value)}
            />
          </span>
          <span>
            <div className="text-red-500 mx-3">
              {/* <Button variant="outlined" color="primary" onClick={handleOpen}> */}
              {/* <AddIcon /> */}
              {/* Add Inventry */}
              {/* </Button> */}
              <Modal
                open={open}
                onClose={handleClose}
                aria-labelledby="child-modal-title"
                aria-describedby="child-modal-description"
              >
                <Box
                  sx={{ ...style, width: 430 }}
                  className="rounded-2xl !border-0"
                >
                  <div
                    id="child-modal-title "
                    className="!text-black !underline !font-bold !py-3 !text-center !text-xl"
                  >
                    Update Notification
                  </div>
                  <TextField
                    size="small"
                    id="outlined-basic"
                    label="Subject"
                    variant="outlined"
                    className="!w-[100%] !mt-3"
                    value={subject}
                    onChange={(event) => setSubject(event.target.value)}
                  />
                  <TextField
                    size="small"
                    id="outlined-basic"
                    label="Title"
                    variant="outlined"
                    className="!w-[100%] !mt-3"
                    value={title}
                    onChange={(event) => setTitle(event.target.value)}
                  />
                  <FormControl fullWidth>
                    <InputLabel id="demo-simple-select-label1">
                      Select Tag
                    </InputLabel>
                    <Select
                      labelId="demo-simple-select-label1"
                      id="demo-simple-select1"
                      label="Select Tag"
                      size="small"
                      className="mt-3"
                      name="main_category_id"
                      value={tag || rowData?.tag || ""}
                      onChange={(event) => setTag(event.target.value)}
                    >
                      {tagData?.map((elem) => (
                        <MenuItem value={elem}>{elem}</MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                  <FormControl fullWidth>
                    <InputLabel id="demo-simple-select-label">
                      Select Heading
                    </InputLabel>
                    <Select
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      label="Select Main Category"
                      size="small"
                      className="mt-3"
                      name="sub_category_id"
                      value={subject || rowData?.subject || ""}
                      onChange={(event) => setHeading(event.target.value)}
                    >
                      {subjectData?.map((elem) => (
                        <MenuItem value={elem}>{elem}</MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                  {/* <TextField
                    size="small"
                    id="outlined-basic"
                    label="
                    Description"
                    variant="outlined"
                    className="!w-[100%] !mt-3"
                    name="description"
                    value={description}
                    onChange={(event) => setDescription(event.target.value)}
                  /> */}
                  <textarea
                    value={description}
                    rows="4"
                    className="!w-[100%] py-3 rounded-md !mt-3 border p-2 border-slate-300"
                    onChange={(event) => setDescription(event.target.value)}
                  ></textarea>
                  {/* <EmptyTextarea 
                  className="!w-full"
                  value={description}
                  onChange={(event) => setDescription(event.target.value)}
                   /> */}

                  <br />
                  <br />
                  <Button
                    onClick={hangleCancel}
                    variant="contained"
                    color="warning"
                    className="!py-2 !mt-3"
                  >
                    CANCEL
                  </Button>
                  <Button
                    variant="contained"
                    type="submit"
                    color="success"
                    className="!py-2 !px-5 !font-bold !mt-3 !float-right"
                    onClick={updateNotification}
                  >
                    UPDATE
                  </Button>
                </Box>
              </Modal>
            </div>
          </span>
        </div>
        <TableContainer
          component={Paper}
          // sx={{  }}
          sx={{ width: "100%", maxHeight: 440 }}
          className="!text-black !mx-auto !bg-white overflow-auto px-2"
        >
          <Table stickyHeader aria-label="sticky table" size="small">
            <TableHead>
              <TableRow>
                {/* <TableCell className="!text-left !p-2">
                  <Checkbox className="!m-0 !text-black" />
                </TableCell> */}
                <TableCell
                  style={{
                    borderRight: "1px solid #D0D0D0",
                    fontFamily: "'Poppins', sans-serif",
                  }}
                  className="!text-center !text-gray-800 !font-bold"
                >
                  ID
                </TableCell>
                <TableCell
                  style={{
                    borderRight: "1px solid #D0D0D0",
                    fontFamily: "'Poppins', sans-serif",
                  }}
                  className="!text-center !text-gray-800 !font-bold"
                >
                  <div className="w-24">SUBJECT</div>
                </TableCell>
                <TableCell
                  style={{
                    borderRight: "1px solid #D0D0D0",
                    fontFamily: "'Poppins', sans-serif",
                  }}
                  className="!text-center !text-gray-800 !font-bold"
                >
                  TAG
                </TableCell>
                <TableCell
                  style={{
                    borderRight: "1px solid #D0D0D0",
                    fontFamily: "'Poppins', sans-serif",
                  }}
                  className="!text-center !text-gray-800 !font-bold"
                >
                  <div className="w-36">HEADING </div>
                </TableCell>
                <TableCell
                  style={{
                    borderRight: "1px solid #D0D0D0",
                    fontFamily: "'Poppins', sans-serif",
                  }}
                  className="!text-center !text-gray-800 !font-bold"
                >
                  <div className="w-40">TITLE </div>
                </TableCell>
                {/* <TableCell
                  style={{
                    borderRight: "1px solid #D0D0D0",
                    fontFamily: "'Poppins', sans-serif",
                  }}
                  className="!text-center !text-gray-800 !font-bold"
                >
                  <div className="w-40">IMAGE</div>
                </TableCell> */}
                <TableCell
                  style={{
                    borderRight: "1px solid #D0D0D0",
                    fontFamily: "'Poppins', sans-serif",
                  }}
                  className="!text-center !text-gray-800 !font-bold"
                >
                  <div className="w-52">DESCRIPTION </div>
                </TableCell>
                <TableCell
                  style={{
                    fontFamily: "'Poppins', sans-serif",
                  }}
                  className="!text-center !text-gray-800 !font-bold"
                >
                  ACTION
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody className="!bg-red">
              {data &&
                data?.map((row, index) => (
                  <TableRow key={row.id} className="!text-slate-700">
                    <TableCell
                      className="!text-center !text-[12px]"
                      style={{
                        borderRight: "1px solid #D0D0D0",
                        fontFamily: "'Poppins', sans-serif",
                      }}
                    >
                      {row.id ? row.id : "--"}
                    </TableCell>
                    <TableCell
                      className="!text-center !text-[12px]"
                      style={{
                        borderRight: "1px solid #D0D0D0",
                        fontFamily: "'Poppins', sans-serif",
                      }}
                    >
                      {row?.subject ? row?.subject : "--"}
                    </TableCell>
                    <TableCell
                      className="!text-center !text-[12px]"
                      style={{
                        borderRight: "1px solid #D0D0D0",
                        fontFamily: "'Poppins', sans-serif",
                      }}
                    >
                      {row?.tag ? row?.tag : "--"}
                    </TableCell>
                    <TableCell
                      className="!text-center !text-[12px]"
                      style={{
                        borderRight: "1px solid #D0D0D0",
                        fontFamily: "'Poppins', sans-serif",
                      }}
                    >
                      {row?.heading ? row?.heading : "--"}
                    </TableCell>

                    <TableCell
                      className="!text-center !text-[12px]"
                      style={{
                        borderRight: "1px solid #D0D0D0",
                        fontFamily: "'Poppins', sans-serif",
                      }}
                    >
                      {row?.title ? row?.title : "--"}
                    </TableCell>
                    {/* <TableCell
                      className="!text-center !text-[12px]"
                      style={{
                        borderRight: "1px solid #D0D0D0",
                        fontFamily: "'Poppins', sans-serif",
                      }}
                    >
                      {row?.image ? (
                        <img src={row?.image} className="h-8 mx-auto w-8" />
                      ) : (
                        "--"
                      )}
                    </TableCell> */}
                    <TableCell
                      className="!text-center !text-[12px]"
                      style={{
                        borderRight: "1px solid #D0D0D0",
                        fontFamily: "'Poppins', sans-serif",
                      }}
                    >
                      {row?.body ? row?.body : "--"}
                    </TableCell>
                    <TableCell
                      className="!text-center !text-[12px]"
                      style={{
                        fontFamily: "'Poppins', sans-serif",
                      }}
                    >
                      <BorderColorIcon
                        className="text-green-500"
                        onClick={(event) => editFunctionality(event, row)}
                      />
                    </TableCell>
                  </TableRow>
                ))}
            </TableBody>
          </Table>
        </TableContainer>
        <div
          className="!float-right relative bg-white w-[100%] mx-auto bottom-0 right-0 py-3 border-t-2 border-gray-400 !flex-col !justify-end !items-center"
          style={{ marginRight: "0px" }}
        >
          <button className="!float-right">
            <ArrowForwardIosIcon />
          </button>
          <button className="float-right">
            <ArrowBackIosIcon />
          </button>
        </div>
      </div>
    </div>
  );
};

export default CustomNotification;
